<script setup lang="ts">
import NxCheckbox from './NxCheckbox.vue';

const props = withDefaults(
  defineProps<{
    label: string;
    disabled?: boolean;
    /**
     * `ribbon` is the office ribbon's toggle (Write's „Anzeigen“ group): the
     * ribbon's small checkbox, its type and a tight gap, one line high.
     */
    size?: 'default' | 'ribbon';
    /** Mixed state of the box (see NxCheckbox `indeterminate`). */
    indeterminate?: boolean;
  }>(),
  { disabled: false, size: 'default', indeterminate: false }
);

const model = defineModel<boolean>({ required: true });
</script>

<template>
  <label
    class="nx-checkbox-field"
    :class="{ disabled: props.disabled, 'size-ribbon': props.size === 'ribbon' }"
  >
    <NxCheckbox
      v-model="model"
      :disabled="disabled"
      :size="props.size"
      :indeterminate="props.indeterminate"
    />
    <span class="nx-checkbox-field-label">{{ label }}</span>
    <slot />
  </label>
</template>

<style scoped>
.nx-checkbox-field {
  display: inline-flex;
  align-items: center;
  gap: var(--nxt-space-xs);
  cursor: pointer;
  font-size: var(--nxt-font-size-sm);
  color: var(--nxt-label-fg);
}

.nx-checkbox-field.disabled {
  cursor: not-allowed;
}

/* NxCheckbox already recolors its own disabled state via --nxt-*-disabled
   tokens; only the label text needs muting here (no opacity on the field). */
.nx-checkbox-field.disabled .nx-checkbox-field-label {
  color: var(--nxt-disabled-fg);
}

.nx-checkbox-field-label {
  line-height: 1.3;
}

.nx-checkbox-field.size-ribbon {
  gap: calc(var(--nxt-size-unit) * 0.4375);
  color: var(--office-ribbon-fg, var(--nxt-label-fg));
  font-size: var(--office-ribbon-font-size, var(--nxt-font-size-xs));
  white-space: nowrap;
}

.nx-checkbox-field.size-ribbon .nx-checkbox-field-label {
  line-height: 1.5;
}
</style>
